import BaaiDeClub from "../assets/images/baai_de_club.svg?react";
import BootjeVarenBreda from "../assets/images/bootje_varen_breda_white.svg?react";
import FooterVideo from "../assets/videos/Footer_Bootje_1920x100.mp4";

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="container flex justify-between items-center py-4">
        <BootjeVarenBreda className="w-20 h-20 text-white" />
        <BaaiDeClub className="w-64 text-white" />
      </div>
      <div className="w-full h-6 relative">
        <div className="overflow-hidden absolute inset-0">
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            src={FooterVideo}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </footer>
  );
}
